import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback } from 'react';
import { ScrollElement } from '@/components/functional/Scroll/ScrollElement/ScrollElement';
import { ContentContainer } from '@/components/ui/Layout/ContentContainer/ContentContainer';
import { FaqSearch } from '@/container/Client/MyPage/MyPageCommon/Faq/FaqSearch';
import { scrollToWithHeaderHeight } from '@/helpers/ScrollUtils';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { pagePath } from '@/utils/router/pagePath';
import Navigation from '../../../../../../../container/Client/MyPage/MyPageCommon/Navigation/Navigation';
// TODO: Navigation の TS化をしたら定数をそっちに移動する
export const CLIENT_MYPAGE_LAYOUT_TAB_VALUE_MYPAGE = 'mypage';
export const CLIENT_MYPAGE_LAYOUT_TAB_VALUE_PROJECT = 'project';
export const CLIENT_MYPAGE_LAYOUT_TAB_VALUE_CONSULTATIONS = 'consultations';
export const CLIENT_MYPAGE_LAYOUT_TAB_VALUE_HOTLINE = 'hotline';
/**
 * 企業側 共通 Layout
 * TODO: Layout コンポーネントもTS化したらここに組み込む
 */
export const ClientMyPageLayout = (props) => {
    const { children, className = '', rfpUnreadCount, tabValue } = props;
    const history = useNavigate();
    /**
     * よくあるご質問のリンク押下時のイベント
     */
    const onClickFaqSearchLink = useCallback((e) => {
        e.preventDefault();
        if (tabValue === CLIENT_MYPAGE_LAYOUT_TAB_VALUE_MYPAGE) {
            // マイページタブの場合はスクロール
            scrollToWithHeaderHeight('mypage_navigation');
        }
        else {
            // それ以外の場合はマイページタブへ遷移
            history.push(pagePath.mypage.client.index());
        }
    }, [history, tabValue]);
    return (_jsxs("div", Object.assign({ className: clsx('client_mypage', 'pt-[15px] xl:pt-40', className) }, { children: [_jsxs(ContentContainer, Object.assign({ className: clsx('mx-auto', className), isMinWidthFull: true, maxWidthPoint: 'lg' }, { children: [tabValue === CLIENT_MYPAGE_LAYOUT_TAB_VALUE_MYPAGE ? (_jsx(ScrollElement, Object.assign({ name: 'mypage_navigation' }, { children: _jsx(Navigation, { activeTab: tabValue, rfpUnreadCount: rfpUnreadCount }) }))) : (_jsx(Navigation, { activeTab: tabValue, rfpUnreadCount: rfpUnreadCount })), children] })), _jsx(FaqSearch, { onClickMyPageLink: onClickFaqSearchLink, type: tabValue === CLIENT_MYPAGE_LAYOUT_TAB_VALUE_HOTLINE
                    ? 'hotline'
                    : 'default' })] })));
};
